import { Component } from "solid-js";

interface GamingIconProps {
  class?: string;
}

export const GamingIcon: Component<GamingIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M8 13.3334H12"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99992 11.3333V15.3333"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.199 7.16815C19.6197 4.7217 12.3802 4.7217 5.80087 7.16815C4.64596 7.63072 3.77932 8.61423 3.46574 9.81816C2.36289 14.5772 2.40155 19.5297 3.57855 24.271C3.81698 25.1291 4.46759 25.8118 5.31322 26.0913L6.83188 26.5974C7.49958 26.8227 8.22703 26.4872 8.48912 25.8331C9.02308 24.4981 9.88619 22.3403 10.3577 21.1616C10.56 20.6565 11.05 20.3259 11.594 20.3275H20.4054C20.9507 20.3275 21.441 20.6595 21.6435 21.1658L23.5079 25.8274C23.7701 26.4829 24.4979 26.8205 25.1676 26.5972L26.6869 26.0907C27.5324 25.8112 28.1829 25.1285 28.4213 24.2705C29.5981 19.5294 29.6368 14.5771 28.5341 9.81822C28.2205 8.61426 27.3539 7.63074 26.199 7.16815Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.1334 13.3336C19.1332 13.4624 19.0288 13.5667 18.9 13.5667C18.7712 13.5666 18.6668 13.4622 18.6667 13.3335C18.6667 13.2047 18.771 13.1002 18.8998 13.1C18.9618 13.0999 19.0212 13.1245 19.0651 13.1684C19.1089 13.2122 19.1335 13.2717 19.1334 13.3336"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.0001 13.3336C23.9999 13.4624 23.8955 13.5667 23.7667 13.5667C23.6379 13.5666 23.5335 13.4622 23.5334 13.3335C23.5334 13.2047 23.6377 13.1002 23.7665 13.1C23.8285 13.0999 23.8879 13.1245 23.9318 13.1684C23.9756 13.2122 24.0002 13.2717 24.0001 13.3336"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.3337 15.5334C21.4625 15.5335 21.5668 15.638 21.5667 15.7668C21.5667 15.8956 21.4623 16 21.3335 16C21.2047 16.0001 21.1002 15.8958 21.1001 15.767C21.1 15.705 21.1246 15.6455 21.1684 15.6017C21.2123 15.5579 21.2717 15.5333 21.3337 15.5334"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.3337 10.6667C21.4625 10.6668 21.5668 10.7713 21.5667 10.9001C21.5667 11.0289 21.4623 11.1333 21.3335 11.1333C21.2047 11.1334 21.1002 11.0291 21.1001 10.9003C21.1 10.8383 21.1246 10.7788 21.1684 10.735C21.2123 10.6912 21.2717 10.6666 21.3337 10.6667"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
